export { default as PoliciesFooter } from "./PoliciesFooter";
export type { PolicyTemplate, PolicyLink, PolicyType } from "./PoliciesFooter";
export { default as SinglePaymentPolicyFooter } from "./SinglePaymentPolicyFooter";
export { default as SubscriptionPaymentPolicyFooter } from "./SubscriptionPaymentPolicyFooter";
